<div class="row" style="margin-top: 15px;margin-left: 10px;">
	<div class="col-12">
		
			{{msg}}
		
	</div>
	<div class="col-12 theme-font-color" [innerHTML]="content"></div>
</div>
<div class="row" style="margin-top: 15px;margin-left: 10px;">
	<div class="col-1">
		<button *ngIf="showCancelBtn" mat-raised-button color="warn" (click)="closeDialog(false)">Cancel</button>
	</div>
	<div class="col-1"></div>
	<div class="col-1">
		<button mat-raised-button color="primary" (click)="closeDialog(true)" cdkFocusInitial>Ok</button>
	</div>

</div>